import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"

import Navigation from "./navigation"

const Header = ({ logo }) => {
    const { site } = useStaticQuery(
        graphql`
            query {
                site {
                    siteMetadata {
                        title
                        menuItems
                        contactEmail
                    }
                }
            }
        `
    )

    // const title = site.siteMetadata?.title
    const menu = site.siteMetadata?.menuItems
    const email = site.siteMetadata?.contactEmail

    return (
        <header className="header">
            <div className="container">
                <Link to="/">
                    <img className="logo" src={logo} alt="Our logo" />
                </Link>
                <Navigation menuItems={menu} email={email} />
            </div>
        </header>
    )
}

export default Header
